/* ==========================================================================
   cc-funnel-popup — Auslöser + Wiedervorlage
   Angelegt 2026-08-06 (Alwin).

   Drei Auslöser, ODER-verknüpft (der erste gewinnt), alle im Customizer
   ein-/ausschaltbar:
     1. Verweildauer  (data-delay,  Sekunden; 0 = aus)
     2. Scrolltiefe   (data-scroll, Prozent;  0 = aus)
     3. Exit-Intent   (data-exit,   nur Desktop mit echtem Mauszeiger)

   Wiedervorlage über localStorage (data-repeat-days). Wer schließt oder
   klickt, sieht es so lange nicht wieder. Pro Seitenaufruf höchstens einmal.

   BEWUSST KEIN Analytics-Event: Die Conversion misst Meta, sobald im nächsten
   Schritt auf der Landing die E-Mail eingetragen wird (Alwins Vorgabe).
   ========================================================================== */
(function () {
  'use strict';

  var pop = document.querySelector('[data-cc-pop]');
  if (!pop) return;

  var box = pop.querySelector('.cc-pop__box');
  var KEY = 'ccPopupSeen';

  var delayS = parseInt(pop.getAttribute('data-delay'), 10) || 0;
  var scrollP = parseInt(pop.getAttribute('data-scroll'), 10) || 0;
  var useExit = pop.getAttribute('data-exit') === 'true';
  var startZeit = Date.now();
  var EXIT_SCHONFRIST_MS = 8000;   // frühestens 8 s nach Seitenaufbau

  // Traffic-Filter (Alwin 15.08.: ab naechster Woche nur Werbe-Traffic; Schalter im
  // Customizer). Paid-Erkennung beim Einstieg, gemerkt fuer die ganze Sitzung —
  // das Pop-up erscheint ja meist erst Seiten spaeter. Brand-Kampagnen (utm_campaign
  // enthaelt den Ausschluss-Begriff) werden hart geblockt, damit Wettbewerber, die
  // nach danario suchen, den Funnel nicht sehen.
  // Nur auf Handys (Alwin 17.08.2026): Am Desktop stoert das Pop-up mehr als es
  // bringt. Schwelle 768 px = Theme-Grenze "medium"; zusaetzlich ein Touch-Check,
  // damit ein schmales Desktop-Fenster nicht faelschlich als Handy zaehlt.
  if (pop.getAttribute('data-mobile-only') === 'true') {
    var istHandy = window.matchMedia('(max-width: 767px)').matches
      && (('ontouchstart' in window) || navigator.maxTouchPoints > 0);
    if (!istHandy) return;
  }

  var paidOnly = pop.getAttribute('data-paid-only') === 'true';
  var paidExcl = (pop.getAttribute('data-paid-exclude') || '').toLowerCase();
  try {
    var q = new URLSearchParams(location.search);
    var camp = (q.get('utm_campaign') || '').toLowerCase();
    if (paidExcl && camp && camp.indexOf(paidExcl) >= 0) sessionStorage.setItem('ccPopBlock', '1');
    var med = (q.get('utm_medium') || '').toLowerCase();
    var src = (q.get('utm_source') || '').toLowerCase();
    var isPaid = q.get('gclid') || q.get('gbraid') || q.get('wbraid') || q.get('fbclid') || q.get('ttclid') || q.get('msclkid')
      || ['cpc', 'paid', 'paid_social', 'ppc'].indexOf(med) >= 0
      || ['facebook', 'instagram', 'fb', 'ig', 'meta'].indexOf(src) >= 0;
    if (isPaid && sessionStorage.getItem('ccPopBlock') !== '1') sessionStorage.setItem('ccPopPaid', '1');
  } catch (e) {}
  if (paidOnly) {
    try {
      if (sessionStorage.getItem('ccPopBlock') === '1' || sessionStorage.getItem('ccPopPaid') !== '1') return;
    } catch (e) { return; }
  }
  var repeatD = parseInt(pop.getAttribute('data-repeat-days'), 10);
  if (isNaN(repeatD)) repeatD = 7;

  var opened = false, done = false, timer = null, lastFocus = null;

  /* --- Bilder vorladen -------------------------------------------------
     Die Bilder stehen im Markup auf loading="lazy". Weil das Pop-up beim
     Seitenaufbau `hidden` ist, fordert der Browser sie dann NICHT an — beim
     Öffnen bliebe der Bildbereich sonst leer (live nachgewiesen 2026-08-06).
     Deshalb: einmal im Leerlauf nachladen, wenn die Seite ohnehin fertig ist,
     und beim Öffnen sicherheitshalber erzwingen. Kostet nichts, solange das
     Pop-up nicht erscheint — die beiden Bilder sind zusammen ~80 KB. */
  var preloaded = false;
  function preload() {
    if (preloaded) return;
    preloaded = true;
    var imgs = pop.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) imgs[i].setAttribute('loading', 'eager');
  }
  var idle = window.requestIdleCallback || function (fn) { return window.setTimeout(fn, 1); };
  window.setTimeout(function () { idle(preload); }, 3000);

  /* --- Wiedervorlage: schon gesehen? ------------------------------------ */
  function seenRecently() {
    if (repeatD <= 0) return false;
    try {
      var t = parseInt(window.localStorage.getItem(KEY), 10);
      if (!t) return false;
      return (Date.now() - t) < repeatD * 86400000;
    } catch (e) {
      return false; // Privater Modus o. Ä. — dann lieber zeigen als gar nicht
    }
  }
  function remember() {
    try { window.localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
  }

  /* --- Öffnen / Schließen ---------------------------------------------- */
  function open() {
    if (opened || done || seenRecently()) return;
    opened = true;
    teardown();
    preload();

    lastFocus = document.activeElement;
    pop.hidden = false;
    // Reflow erzwingen, damit die Einblend-Transition greift
    void pop.offsetWidth;
    pop.classList.add('is-open');
    document.addEventListener('keydown', onKey);
    if (box) { box.setAttribute('tabindex', '-1'); box.focus({ preventScroll: true }); }
  }

  function close() {
    if (!opened) return;
    opened = false; done = true;
    remember();
    pop.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    window.setTimeout(function () { pop.hidden = true; }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function onKey(e) { if (e.key === 'Escape' || e.keyCode === 27) close(); }

  /* --- Auslöser abbauen, sobald einer gefeuert hat ---------------------- */
  function teardown() {
    if (timer) { window.clearTimeout(timer); timer = null; }
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onExit);
  }

  function onScroll() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h <= 0) return;
    if ((window.pageYOffset / h) * 100 >= scrollP) open();
  }

  function onExit(e) {
    // Nur wenn der Zeiger oben aus dem Fenster geht und nicht in ein Kindelement
    if (e.clientY > 0 || e.relatedTarget) return;
    // Schonfrist: Ohne sie feuert der Exit-Intent schon in den ersten Sekunden — der Zeiger
    // steht beim Laden oft ausserhalb des Fensters oder faehrt kurz zur Adressleiste.
    // Getestet 15.08.2026: Pop-up ging nach 2 s auf statt nach den eingestellten 15 s.
    // Exit-Intent soll Absprünge auffangen, nicht Ankommende überfallen.
    if (Date.now() - startZeit < EXIT_SCHONFRIST_MS) return;
    open();
  }

  /* --- Auslöser scharf schalten ---------------------------------------- */
  if (seenRecently()) return;

  if (delayS > 0) timer = window.setTimeout(open, delayS * 1000);
  if (scrollP > 0) window.addEventListener('scroll', onScroll, { passive: true });

  // Exit-Intent nur, wo es einen echten Mauszeiger gibt — auf Touch sinnlos
  var hasMouse = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (useExit && hasMouse) document.addEventListener('mouseout', onExit);

  /* --- Schließen-Elemente + CTA ---------------------------------------- */
  pop.addEventListener('click', function (e) {
    if (e.target.closest('[data-cc-pop-close]')) { e.preventDefault(); close(); return; }
    // Klick auf den CTA: merken, damit es nicht wiederkommt. Der Link selbst
    // läuft normal weiter (neuer Tab), deshalb kein preventDefault.
    if (e.target.closest('[data-cc-pop-go]')) { remember(); done = true; }
  });
})();
